<ng-container [formGroup]="companyNameForm">
  <div class="card-body">
    <div class="d-flex">
      <h2 class="section-heading">Create Customer </h2>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Company Name *</label>
        <input
          type="text"
          id="name"
          formControlName="name"
          class="form-control"
          placeholder="Start typing company name..."
          name="name"
          [options]="placeOptions"
          ngx-google-places-autocomplete
          #placesRef="ngx-places"
          (onAddressChange)="handlePlaceChange($event)">
        <app-validation-error [formGroup]="companyNameForm" [controlName]="'name'"></app-validation-error>
      </div>
    </div>
  </div>
</ng-container>
